'use strict';

angular.module('cgmemApp')
	.factory('WorkingAccount', function ($q, $http, $log, $rootScope, Account, Member, Pass) {

		var currentAccountId = '0';		// default is the default account
		var aggregatePromise = null;
		var aggregate = { account: null, members: [], transactions: [] };

		var api = {};

		api.get = function (requestedId, reload) {
			//$log.log("WorkingAccount: requested Account:",requestedId || 'default');
			if (requestedId && requestedId != currentAccountId) {	// need to reinitialize
				//$log.log("WorkingAccount: switching from account",currentAccountId,"to",requestedId);
				aggregatePromise = null;
				currentAccountId = requestedId;
			}
			if (reload)
				aggregatePromise = null;

			if (!aggregatePromise) {
				//aggregate.account = aggregate.members = aggregate.transactions = null;
				aggregatePromise = Account.get({ accountId: currentAccountId }).$promise
					.then(function (a) {
						aggregate.account = a;
						// get the members
						var memberPromises = [];
						_.forEach(aggregate.account.members, function (m) {
							memberPromises.push(Member.get({ accountId: a._id, memberId: m }).$promise);
						});
						return $q.all(memberPromises);
					})
					.then(function (members) {
						aggregate.members = members;
						return $q.all([
									$http.get('/api/accounts/' + aggregate.account._id + '/transactions'),
									Pass.get(aggregate.account._id, "guestPass")
						]);
					})
					.then(function (r) {
						aggregate.transactions = r[0].data;
						aggregate.guestPasses = r[1].length;
						return aggregate;
					})
					.catch(function (err) {
						$log.error("WorkingAccount: Get failed:", err);
						aggregatePromise = null;
						aggregate = { account: null, members: [], transactions: [] };
						return $q.reject(err);
					});
			}
			return aggregatePromise;
		}


		api.getSync = function () {																		// returns the WORKING account
			return aggregate;
		}

		api.pushMember = function (m) {		// a single member RESOURCE
			if (aggregate.members)
				aggregate.members.push(m);
		}

		api.pushTransactions = function (t) {	// an array of transaction objects
			if (aggregate.transactions)
				aggregate.members.push.apply(t)
		}

		$rootScope.$on('$sessionEnd', function () {
			//$log.log('Working Account: $sessionEnd: resetting')
			currentAccountId = '0';		// default is the default account
			aggregatePromise = null;
			aggregate = { account: null, members: [], transactions: [] };
		});

		return api;
	});


angular.module('cgmemApp')
	.factory('Account', function ($resource) {

		return $resource('/api/accounts/:accountId', { accountId: '@_id' }, {
			'update': {
				method: 'PUT'
			}
		});
	});

